// import manvarLogo from '../../../../assets/img/manvar.png'
// import jsPDF from "jspdf";
import 'jspdf-autotable';

export const useHelpers = () => {

    // const defaultFontSize = 10
    // const titleFontSize = 15

    const getCurrentDate = () => {
        const today = new Date(); // Crea un objeto de fecha con la fecha actual
        const year = today.getFullYear(); // Obtiene el año
        const month = today.getMonth() + 1; // Obtiene el mes (getMonth() devuelve un índice basado en cero, por lo que se suma 1)
        const day = today.getDate(); // Obtiene el día del mes

        // Formatea la fecha en 'YYYY-MM-DD', asegurándote de agregar un cero delante de meses y días menores a 10
        return `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`;
    }

    const getCurrentStartMonth = () => {
        const today = new Date(); // Crea un objeto de fecha con la fecha actual
        const year = today.getFullYear(); // Obtiene el año
        const month = today.getMonth() + 1; // Obtiene el mes (getMonth() devuelve un índice basado en cero, por lo que se suma 1)


        // Formatea la fecha en 'YYYY-MM-DD', asegurándote de agregar un cero delante de meses y días menores a 10
        return `${year}-${month < 10 ? `0${month}` : month}-01`;
    }

    const formatMoney = (value) => {
        const num = typeof value === 'string'
            ? parseFloat(value.replace(/,/g, ''))
            : Number(value);

        if (isNaN(num)) return '0.00';

        return num.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    };

    const convertToFloat = (formattedNumber) => {
        if (formattedNumber === null || formattedNumber === undefined) return 0;

        const cleanedValue = String(formattedNumber).replace(/,/g, '');
        const floatValue = parseFloat(cleanedValue);

        return isNaN(floatValue) ? 0 : floatValue;
    };


    return Object.freeze({
        getCurrentDate,
        getCurrentStartMonth,
        formatMoney,
        convertToFloat,
    })
}